export default "<ng-snotify></ng-snotify>\n<router-outlet></router-outlet>\n\n"